import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

export const analyticsRouteElements = [
  {
    segment: 'analytics',
    element: lazyModulePage('analytics', () => import('@/soluqr/modules/analytics/screens/AnalyticsPage')),
  },
  {
    segment: 'reports',
    element: lazyModulePage('analytics', () => import('@/soluqr/modules/analytics/screens/ReportsPage')),
  },
];
